import api from "@/lib/api";

export default {
    urlGetAll: "/api/v1/financial/bank/get-all",
    urlCreate: "/api/v1/financial/bank/create",
    urlUpdate: "/api/v1/financial/bank/update",
    urlDelete: "/api/v1/financial/bank/delete",

    async getAll(params) {
        const response = await api.get(this.urlGetAll, {
            params: { search: "", filter: "contains", currentPage: 1, totalPerPage: 10, ...params },
        });
        return response.data;
    },
    async create(model) {
        const response = await api.post(this.urlCreate, model);
        return response.data;
    },
    async update(model) {
        const response = await api.post(this.urlUpdate, model);
        return response.data;
    },
    async delete(ids) {
        const response = await api.post(this.urlDelete, { ids });
        return response.data;
    },
};
